<template>
  <div class="my_input_layer m-lr-11">
    <p :class="type == 'one_level' ? 'set_one_level': 'set_two_level'">
      <span
        v-text="title"
        class="title"
        :style="{
        width: !Number.isNaN(Number(titleWidth)) ? titleWidth + 'px' : titleWidth
      }"
      :class="{'title-before': requiredStatus}"
      ></span>
      <el-input
        :type="inputType"
        :rows="rows"
        class="module"
        v-model="Result"
        :placeholder="placeholder"
        :disabled="disabled"
        size="small"
        :resize="resize"
        :style="{
          width: width+ 'px'
        }"
        @change="change"
        @blur="blur"
        @input="input"
        @click.native="select_text($event)"
        :maxlength="maxlength"
        :show-word-limit="showWordLimit"
      ></el-input>
    </p>
  </div>
</template>

<script>
export default {
  name: 'my_input_index',
  props: {
    titleWidth: {
      type: String,
      default: '40'
    },
    title: { // 组件的标题
      type: String,
      default: ''
    },
    type: { // 组件的类型  one_level 一级组件 two_level 二级组件
      type: String,
      default: 'two_level'
    },
    value: { // 输入框的值
      type: [Number, String],
      default: ''
    },
    placeholder: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    },
    width: {
      type: String,
      default: '118'
    },
    inputType: {
      type: String,
      default: 'text'
    },
    rows: {
      type: Number,
      default: 1
    },
    resize: {
      type: String,
      default: 'both'
    },
    maxlength: {
      type: Number,
      default: Infinity
    },
    showWordLimit: {
      type: Boolean,
      default: false
    },
    requiredStatus: {
      type:Boolean,
      default: false
    }
  },
  data () {
    return {
      Result: this.value
    }
  },
  watch: {
    Result (val) {
      this.$emit('update:value', val);//双向数据绑定
    },
    value (val) {
      this.Result = this.value
    }
  },
  computed: {
  },
  methods: {
    select_text (e) {
      e.target.select()
    },
    change () {
      this.$emit('change', this.Result);
    },
    blur () {
      this.$emit('blur', this.Result);
    },
    input () {
      this.$emit('input', this.Result)
    }
  }
}
</script>

<style scoped type="text/css" lang="scss">
  .my_input_layer {
    /deep/ .el-input--small .el-input__inner {
      text-overflow: ellipsis;
    }
    .title {
      flex-shrink: 0;
    }
    .title-before::before{
      content: '*';
      color:red;
      margin-right:3px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/my_input/index.vue